import { Link } from "react-router-dom";

interface SectionHeadingProps {
  eyebrow?: string;
  title: string;
  description?: string;
  actionLabel?: string;
  actionTo?: string;
}

export default function SectionHeading({
  eyebrow,
  title,
  description,
  actionLabel,
  actionTo,
}: SectionHeadingProps) {
  return (
    <div className="mb-6 flex flex-col gap-4 sm:flex-row sm:items-end sm:justify-between md:mb-8">
      <div>
        {eyebrow && (
          <p className="mb-2 flex items-center gap-2 font-label text-xs tracking-[0.3em] text-accent-500">
            <span className="inline-block h-px w-6 bg-accent-500/70" />
            {eyebrow}
          </p>
        )}
        <h2 className="font-heading text-xl font-bold tracking-wide text-foreground-50 md:text-2xl">
          {title}
        </h2>
        {description && (
          <p className="mt-2 max-w-2xl text-sm leading-6 text-foreground-400">{description}</p>
        )}
      </div>
      {actionLabel && actionTo && (
        <Link
          to={actionTo}
          className="group inline-flex shrink-0 items-center gap-1.5 whitespace-nowrap rounded-md border border-background-700 px-3.5 py-2 text-xs text-foreground-300 transition-colors hover:border-accent-500/60 hover:text-accent-400"
        >
          {actionLabel}
          <i className="ri-arrow-right-line text-sm transition-transform group-hover:translate-x-0.5" />
        </Link>
      )}
    </div>
  );
}